export const CUSTOM_QUERIES = {
  UPDATE_CART_CUSTOM: { updateCart: 'custom-update-cart' },
  REPLICATE_CART: { replicateCart: 'custom-replicate-cart' },
  THANK_YOU_PAGE_ORDER: { getMyOrders: 'thank-you-page-order-query' },
  PRODUCT_SEARCH: {
    mainProductQuery: { products: 'main-product-query' },
    relatedProductQuery: { products: 'related-product-query' },
    extraGuaranteeQuery: { products: 'extra-guarantee-query' },
    tagManagerQuery: { products: 'tag-manager-query' },
    productListingQuery: { products: 'product-listing-query' },
    productAlternative: { products: 'product-alternative' },
    productComparison: { products: 'product-comparison' },
    perCategoryQuery: { products: 'product-per-category-query' },
    productListingHydration: { products: 'product-listing-hydration-query' },
    autocompleteHydration: { products: 'product-autocomplete-hydration-query' },
  },
  CATEGORIES: {
    NAVIGATION: 'categories-navigation-query',
    LISTING: 'categories-listing-query',
    TREE: 'categories-tree-query',
    SIBLING: 'sibling-categories-query',
    BY_KEYS: 'categories-by-keys-query',
  },
  REVIEWS: { reviews: 'custom-review-query' },
  SHIPPING: {
    shippingMethods: {
      customShippingMethods: 'custom-shipping-methods',
      shippingMethodsByCart: 'shipping-methods-by-cart',
    },
  },
  STORES: { stores: 'custom-stores-query' },
  COMPLEMENTARY_PRODUCTS: {
    getProductReferencedCategories: { products: 'product-referenced-categories' },
    getProductsByCategories: { products: 'product-by-categories' },
  },
  PASSWORD: {
    customerResetPassword: 'custom-reset-password',
  },
};
